<template>
  <BaseHeader
    v-bind="$attrs"
    v-on="$listeners"
    :styleConfig="styleConfig"
  >
    <slot />
  </BaseHeader>
</template>

<script>
  import BaseHeader from '@base/v2/base-header'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'HeaderXlargePrimary',
    inheritAttrs: false,
    components: {
      BaseHeader,
    },
    data: function () {
      return {
        styleConfig: {
          container: {
            lineHeight: 1,
          },
          header: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.xl,
            fontWeight: FontStyle.weight.xl,
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.styleConfig.header,
        {
          color: this.color.dark2(),
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
